import React, {useState} from 'react';
import ArrButton from '../arr-button/ArrButton';
import './ArrStepper.scss';
import ArrTooltipWrapper from '../arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../assets/images/info-icon.svg';

export interface Step {
  key: string;
  label: string;
  state: 'completed' | 'current' | 'future';
  tooltipTitle?: string;
  tooltip?: string;
}

export interface ArrStepperProps {
  steps: Step[];
  currentStepKey: string;
  onStepChange?: (key: string) => void;
  allowNonLinear?: boolean;
  clickableSteps?: boolean;
  dataTestId;
}

export const ArrStepper: React.FC<ArrStepperProps> = ({
  steps,

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  currentStepKey,
  onStepChange,
  allowNonLinear = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clickableSteps = false,
  dataTestId,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showTooltip, setShowTooltip] = useState<string | null>(null);

  const handleStepClick = (step: Step) => {
    if (!allowNonLinear && step.state === 'future') return;
    if (step.state !== 'current' && onStepChange) onStepChange(step.key);
  };

  const getStepPositionClass = (index: number) => {
    if (index === 0) return 'first';
    if (index === steps.length - 1) return 'last';
    return 'middle';
  };

  return (
    <div
      role="tablist"
      aria-label="Stepper"
      className="arr-stepper-container"
      data-testid={`arr-stepper-div-${dataTestId}`}
    >
      {steps.map((step, index) => (
        <ArrButton
          key={step.key}
          onClick={() => handleStepClick(step)}
          disabled={
            step.state === 'completed' ||
            (!allowNonLinear && step.state === 'future')
          }
          role="tab"
          aria-current={step.state === 'current' ? 'step' : undefined}
          aria-disabled={
            step.state === 'completed' ||
            (!allowNonLinear && step.state === 'future')
          }
          className={`arr-step ${step.state} ${getStepPositionClass(index)}`}
          dataTestId={`arr-stepper-button-${step.key}`}
        >
          <span
            className="stepper-label"
            data-testid={`arr-stepper-name-${dataTestId}-${step.key}`}
          >
            {step.label}
            {step.state === 'current' && step.tooltip && (
              <ArrTooltipWrapper
                trigger={<InfoIcon fontSize="medium" className="info-icon" />}
                title={step.tooltipTitle}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: step.tooltip || '',
                  }}
                  data-testid={`arr-stepper-inner-html-${dataTestId}`}
                />
              </ArrTooltipWrapper>
            )}
          </span>
        </ArrButton>
      ))}
    </div>
  );
};
